(function() {
    'use strict';
    var dl_OBJ012 = document.querySelector('[dataLayer~=OBJ012]');

    if (dl_OBJ012) {
        var userHasScrolledHalf = false;

        window.addEventListener('scroll', function() {
            var body = document.body,
                html = document.documentElement,
                body_height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight ),
                scrollTop = getScrollTop(),
                w_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

            if ( !userHasScrolledHalf && ( scrollTop + w_height > ( body_height * .5 ) ) ) {
                OBJ012();
                userHasScrolledHalf = true;
            }
        });
    }

    function OBJ012() {
        var data = createch_data.page.ecommerce.detail.products[0];

        dataLayer.push({
            "object": {
                "Id": "OBJ012",
                "name": "Blog - Read at 50%"
            },
            "event": "VPV",
            "ecommerce": {
                "currencyCode": "CAD",
                "checkout": {
                    "actionField": {
                        "step": "1"
                    },
                    "products": [
                        {
                            "name": data.name.trim(),
                            "id": data.id,
                            "price": "1",
                            "brand": "createch canada",
                            "category": data.category,
                            "variant": data.variant,
                            "quantity": "1"
                        }
                    ]
                }
            }
        });
    }

    function getScrollTop(){
        if (typeof pageYOffset!= 'undefined'){
            //most browsers except IE before #9
            return pageYOffset;
        }
        else {
            var B = document.body; //IE 'quirks'
            var D = document.documentElement; //IE with doctype
            D = (D.clientHeight) ? D : B;
            return D.scrollTop;
        }
    }

})();
